import { RecruitingCustomFieldsIndex } from "@/pages/settings/recruit/RecruitingCustomFieldsIndex.tsx";
import { ApiCFEntityTypes } from "@/types/custom-field.types.ts";
import { ApiTokens } from "@/pages/settings/api-tokens/ApiTokens.tsx";
import { HiringFlowsPage } from "@/pages/settings/hiring-flows/index/HiringFlowsPage";
import { HiringFlowEditPage } from "@/pages/settings/hiring-flows/edit/HiringFlowEditPage";
import { ApprovalCategoryPage } from "@/pages/settings/approval-categories/category/ApprovalCategoryPage.tsx";
import { ApprovalCategoriesPage } from "@/pages/settings/approval-categories/index/ApprovalCategoriesPage.tsx";
import { ApprovalPolicyEdit } from "@/pages/settings/approval-policies/edit/ApprovalPolicyEdit.tsx";
import { CalendarHolidayDetails } from "@/pages/settings/calendar-holidays/CalendarHolidayDetails.tsx";
import { CalendarHolidays } from "@/pages/settings/calendar-holidays/CalendarHolidays.tsx";
import { CareerSitesIndex } from "@/pages/settings/career-sites/CareerSitesIndex.tsx";
import { CompensationChangeReasons } from "@/pages/settings/compensation-change-reasons/CompensationChangeReasons.tsx";
import { CompensationComponents } from "@/pages/settings/compensation-components/CompensationComponents.tsx";
import { EmployeeCustomFieldsIndex } from "@/pages/settings/custom-fields/EmployeeCustomFieldsIndex.tsx";
import { EmployeeCustomTable } from "@/pages/settings/custom-fields/EmployeeCustomTable.tsx";
import { DataProtectionSettings } from "@/pages/settings/data-protection/index/DataProtectionSettings.tsx";
import Departments from "@/pages/settings/departments/Departments.tsx";
import Divisions from "@/pages/settings/divisions/Divisions.tsx";
import EmploymentContracts from "@/pages/settings/employment-contracts/EmploymentContracts.tsx";
import EmploymentTypes from "@/pages/settings/employment-types/EmploymentTypes.tsx";
import { FeaturesSettings } from "@/pages/settings/features/FeaturesSettings.tsx";
import { ImportDataEditPage } from "@/pages/settings/import-data/edit/ImportDataEditPage.tsx";
import { ImportDataPage } from "@/pages/settings/import-data/ImportDataPage.tsx";
import SettingsGroupPage from "@/pages/settings/group/SettingsGroupPage.tsx";
import Settings from "@/pages/settings/index/Settings.tsx";
import { SettingsIntegrationGoogleCalendar } from "@/pages/settings/integrations/SettingsIntegrationGoogleCalendar.tsx";
import { SettingsIntegrationGoogleWorkspace } from "@/pages/settings/integrations/SettingsIntegrationGoogleWorkspace.tsx";
import SettingsIntegrations from "@/pages/settings/integrations/SettingsIntegrations.tsx";
import { SettingsIntegrationSlack } from "@/pages/settings/integrations/SettingsIntegrationSlack.tsx";
import { SettingsIntegrationZoom } from "@/pages/settings/integrations/SettingsIntegrationZoom.tsx";
import { SettingsIntegrationTabs } from "@/pages/settings/integrations/settings-integration.types.ts";
import LegalEntities from "@/pages/settings/legal-entities/LegalEntities.tsx";
import Locations from "@/pages/settings/locations/Locations.tsx";
import MetricsConfiguration from "@/pages/settings/metrics-configuration/MetricsConfiguration.tsx";
import { OrganizationListSettings } from "@/pages/settings/organization-lists/OrganizationListSettings.tsx";
import SettingsOrganization from "@/pages/settings/organization/SettingsOrganization.tsx";
import PreboardingSettings from "@/pages/settings/preboarding/PreboardingSettings.tsx";
import HomeLayoutSettings from "@/pages/settings/home-layout/HomeLayoutSettings.tsx";
import { ProbationPolicies } from "@/pages/settings/probation-policies/ProbationPolicies.tsx";
import { RecognitionCategoryPage } from "@/pages/settings/recognitions/category/RecognitionCategoryPage.tsx";
import { RecognitionCategoriesPage } from "@/pages/settings/recognitions/index/RecognitionCategoriesPage.tsx";
import { RecognitionSettingsTabs } from "@/pages/settings/recognitions/index/recognition-settings.types.ts";
import { CandidateDisqualificationReasons } from "@/pages/settings/recruit/disqualification-reasons/CandidateDisqualificationReasons.tsx";
import { JobArchivingReasons } from "@/pages/settings/recruit/job-archiving-reasons/JobArchivingReasons.tsx";
import Labels from "@/pages/settings/recruit/labels/Labels.tsx";
import Pipelines from "@/pages/settings/recruit/pipelines/Pipelines.tsx";
import Sources from "@/pages/settings/recruit/sources/Sources.tsx";
import Templates from "@/pages/settings/recruit/templates/Templates.tsx";
import { RolesEdit } from "@/pages/settings/roles/edit/RoleEdit.tsx";
import RolesV2 from "@/pages/settings/roles/index/Roles.tsx";
import { SecurityPage } from "@/pages/settings/security/SecurityPage.tsx";
import { TimeOffCategoryEdit } from "@/pages/settings/time-off/edit/TimeOffCategoryEdit.tsx";
import { TimeOffSettingsTabs } from "@/pages/settings/time-off/index/time-off-settings.types.ts";
import { TimeOffSettings } from "@/pages/settings/time-off/index/TimeOffSettings.tsx";
import { TimeOffCategoryPolicyEdit } from "@/pages/settings/time-off/policy/TimeOffCategoryPolicyEdit.tsx";
import SettingsOrganizationViewFilter from "@/pages/settings/view-filter/SettingsOrganizationViewFilter.tsx";
import { OrganizationLinks } from "@/pages/settings/organization-links/OrganizationLinks.tsx";
import { WorkPatterns } from "@/pages/settings/work-patterns/WorkPatterns.tsx";
import { WebhooksPage } from "@/pages/settings/webhooks/WebhooksPage.tsx";
import { WebhookDeliveriesPage } from "@/pages/settings/webhooks/WebhookDeliveriesPage.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { DataProtectionSettingsTabs } from "@/types/data-protection.types.ts";
import { ApiOrganizationListType } from "@/types/organization-list.types.ts";
import { ApiPermission, EmployeeFieldPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import { JobFrameworkPage } from "@/pages/settings/jobs/framework/JobFrameworkPage.tsx";
import { JobsPageLayout } from "@/pages/settings/jobs/JobsPageLayout.tsx";
import { JobRolePage } from "@/pages/settings/jobs/roles/JobRolePage.tsx";

export const settingsRoutes: RouteConfig[] = [
  {
    path: "hiring-flows",
    element: <HiringFlowsPage />,
    allOfPermissions: [ApiPermission.settings_hiring_flows],
  },
  {
    path: "hiring-flows/:id",
    element: <HiringFlowEditPage />,
    allOfPermissions: [ApiPermission.settings_hiring_flows],
  },
  { path: "", element: <Settings /> },
  { path: "general", element: <SettingsGroupPage groupKey="general" /> },
  { path: "company-structure", element: <SettingsGroupPage groupKey="company-structure" /> },
  { path: "policies", element: <SettingsGroupPage groupKey="policies" /> },
  { path: "employment", element: <SettingsGroupPage groupKey="employment" /> },
  {
    path: "recruitment-directories",
    element: <SettingsGroupPage groupKey="recruitment-directories" />,
  },
  {
    path: "divisions",
    element: <Divisions />,
    allOfPermissions: [ApiPermission.settings_divisions],
  },
  {
    path: "departments",
    element: <Departments />,
    allOfPermissions: [ApiPermission.settings_departments],
  },
  {
    path: "organization",
    element: <SettingsOrganization />,
    allOfPermissions: [ApiPermission.settings_organization],
  },
  {
    path: "features",
    element: <FeaturesSettings />,
    allOfPermissions: [ApiPermission.settings_organization],
  },
  {
    path: "preboarding",
    element: <PreboardingSettings />,
    allOfPermissions: [ApiPermission.settings_organization],
  },
  {
    path: "home-layout",
    element: <HomeLayoutSettings />,
    allOfPermissions: [ApiPermission.settings_organization],
  },
  {
    path: "metrics-configuration",
    element: <MetricsConfiguration />,
    allOfPermissions: [ApiPermission.settings_organization],
  },
  {
    path: "positions",
    redirect: "/settings/jobs/framework",
  },
  {
    path: "pipelines",
    element: <Pipelines />,
    allOfPermissions: [ApiPermission.settings_pipelines, ApiPermission.recruiting_module],
    planFeature: ApiFeatureType.ats,
  },
  {
    path: "sources",
    element: <Sources />,
    allOfPermissions: [ApiPermission.settings_sources, ApiPermission.recruiting_module],
    planFeature: ApiFeatureType.ats,
  },
  {
    path: "labels",
    element: <Labels />,
    allOfPermissions: [ApiPermission.manage_candidates, ApiPermission.recruiting_module],
    planFeature: ApiFeatureType.ats,
  },
  {
    path: "disqualification-reasons",
    element: <CandidateDisqualificationReasons />,
    allOfPermissions: [
      ApiPermission.settings_candidate_disqualification_reasons,
      ApiPermission.recruiting_module,
    ],
    planFeature: ApiFeatureType.ats,
  },
  {
    path: "job-archiving-reasons",
    element: <JobArchivingReasons />,
    allOfPermissions: [
      ApiPermission.settings_job_archiving_reasons,
      ApiPermission.recruiting_module,
    ],
    planFeature: ApiFeatureType.ats,
  },
  {
    path: "templates",
    element: <Templates />,
    anyOfPermissions: [ApiPermission.settings_templates, ApiPermission.manage_candidates],
  },
  {
    path: "locations",
    element: <Locations />,
    allOfPermissions: [ApiPermission.settings_locations],
  },
  {
    path: "termination-leave-types",
    element: <OrganizationListSettings type={ApiOrganizationListType.termination_leave_types} />,
    allOfEditFieldPermissions: [EmployeeFieldPermission.manage_employee_termination],
  },
  {
    path: "termination-reasons",
    element: <OrganizationListSettings type={ApiOrganizationListType.termination_reasons} />,
    allOfEditFieldPermissions: [EmployeeFieldPermission.manage_employee_termination],
  },
  {
    path: "legal-entities",
    element: <LegalEntities />,
    allOfPermissions: [ApiPermission.settings_legal_entities],
  },
  {
    path: "integrations",
    children: [
      {
        path: "",
        element: <SettingsIntegrations />,
        allOfPermissions: [ApiPermission.settings_integrations],
      },
      {
        path: ":id/slack",
        element: <SettingsIntegrationSlack tab={SettingsIntegrationTabs.settings} />,
        allOfPermissions: [ApiPermission.settings_integrations],
      },
      {
        path: ":id/slack/employees",
        element: <SettingsIntegrationSlack tab={SettingsIntegrationTabs.employees} />,
        allOfPermissions: [ApiPermission.settings_integrations],
      },
      {
        path: ":id/google-workspace",
        element: <SettingsIntegrationGoogleWorkspace />,
        allOfPermissions: [ApiPermission.settings_integrations],
      },
      {
        path: ":id/google-calendar-service-account",
        element: <SettingsIntegrationGoogleCalendar tab={SettingsIntegrationTabs.settings} />,
        allOfPermissions: [ApiPermission.settings_integrations],
      },
      {
        path: ":id/google-calendar-service-account/employees",
        element: <SettingsIntegrationGoogleCalendar tab={SettingsIntegrationTabs.employees} />,
        allOfPermissions: [ApiPermission.settings_integrations],
      },
      {
        path: ":id/zoom",
        element: <SettingsIntegrationZoom />,
        allOfPermissions: [ApiPermission.settings_integrations],
      },
    ],
  },
  {
    path: "holidays",
    element: <CalendarHolidays />,
    allOfPermissions: [ApiPermission.manage_holidays],
  },
  {
    path: "holidays/:id",
    element: <CalendarHolidayDetails />,
    allOfPermissions: [ApiPermission.manage_holidays],
  },
  {
    path: "approval-categories",
    planFeature: ApiFeatureType.approvals,
    allOfPermissions: [ApiPermission.manage_approval_policy],
    children: [
      { path: "", element: <ApprovalCategoriesPage /> },
      { path: ":id", element: <ApprovalCategoryPage /> },
      { path: ":id/policies/new", element: <ApprovalPolicyEdit /> },
      { path: ":id/policies/:policyId", element: <ApprovalPolicyEdit /> },
    ],
  },
  {
    path: "time-off",
    planFeature: ApiFeatureType.time_off,
    allOfPermissions: [ApiPermission.manage_leave_policies],
    children: [
      { path: "", element: <TimeOffSettings tab={TimeOffSettingsTabs.settings} /> },
      {
        path: "policy-report",
        element: <TimeOffSettings tab={TimeOffSettingsTabs.policyReport} />,
      },
      { path: "categories/new", element: <TimeOffCategoryEdit /> },
      { path: "categories/:id", element: <TimeOffCategoryEdit /> },
      { path: "categories/:id/policies/new", element: <TimeOffCategoryPolicyEdit /> },
      { path: "categories/:id/policies/:policy_id", element: <TimeOffCategoryPolicyEdit /> },
    ],
  },
  {
    path: "data-protection",
    allOfPermissions: [ApiPermission.settings_data_protection],
    planFeature: ApiFeatureType.ats_gdpr,
    children: [
      {
        path: "",
        element: <DataProtectionSettings tab={DataProtectionSettingsTabs.settings} />,
      },
      {
        path: "requests",
        element: <DataProtectionSettings tab={DataProtectionSettingsTabs.requests} />,
      },
    ],
  },
  {
    path: "roles-and-permissions",
    allOfPermissions: [ApiPermission.settings_roles_permissions],
    children: [
      { path: "", element: <RolesV2 /> },
      { path: "new", element: <RolesEdit /> },
      { path: ":id", element: <RolesEdit /> },
      { path: "edit/:id", element: <RolesEdit /> },
      { path: "employees", element: <RolesV2 tab="employees" /> },
    ],
  },
  {
    path: "api-tokens",
    element: <ApiTokens />,
    allOfPermissions: [ApiPermission.settings_api_users],
  },
  {
    path: "webhooks",
    element: <WebhooksPage />,
    allOfPermissions: [ApiPermission.settings_webhooks],
  },
  {
    path: "webhooks/:id/deliveries",
    element: <WebhookDeliveriesPage />,
    allOfPermissions: [ApiPermission.settings_webhooks],
  },
  {
    path: "employment-types",
    element: <EmploymentTypes />,
    allOfPermissions: [ApiPermission.settings_employment_types],
  },
  {
    path: "employment-contracts",
    element: <EmploymentContracts />,
    allOfPermissions: [ApiPermission.settings_employment_contracts],
  },
  {
    path: "compensation-change-reasons",
    element: <CompensationChangeReasons />,
    allOfPermissions: [ApiPermission.settings_compensation_change_reasons],
  },
  {
    path: "default-employee-view",
    element: <SettingsOrganizationViewFilter />,
    allOfPermissions: [ApiPermission.settings_organization],
  },
  {
    path: "recruitment-fields",
    allOfPermissions: [ApiPermission.manage_custom_fields, ApiPermission.recruiting_module],
    planFeature: ApiFeatureType.ats,
    children: [
      { path: "", element: <SettingsGroupPage groupKey="recruitment-fields" /> },
      {
        path: "applicant",
        element: <RecruitingCustomFieldsIndex entityType={ApiCFEntityTypes.applicant} />,
      },
      {
        path: "job",
        element: <RecruitingCustomFieldsIndex entityType={ApiCFEntityTypes.job} />,
      },
      {
        path: "offer",
        element: <RecruitingCustomFieldsIndex entityType={ApiCFEntityTypes.offer} />,
      },
    ],
  },
  {
    path: "career-sites",
    element: <CareerSitesIndex />,
    planFeature: ApiFeatureType.ats_career_site,
    allOfPermissions: [ApiPermission.manage_career_sites],
  },
  {
    path: "custom-fields",
    children: [
      { path: "", element: <EmployeeCustomFieldsIndex /> },
      { path: "tab/:tab_id", element: <EmployeeCustomFieldsIndex /> },
      { path: "table/:table_id", element: <EmployeeCustomTable /> },
    ],
    allOfPermissions: [ApiPermission.manage_custom_fields],
  },
  {
    path: "compensation-types",
    element: <CompensationComponents />,
    allOfPermissions: [ApiPermission.settings_compensation_types],
  },
  {
    path: "employee-position-change-reasons",
    element: (
      <OrganizationListSettings type={ApiOrganizationListType.employee_position_change_reasons} />
    ),
    allOfEditFieldPermissions: [EmployeeFieldPermission.manage_employee_position],
  },
  {
    path: "probation-policies",
    element: <ProbationPolicies />,
    allOfPermissions: [ApiPermission.settings_probation_policies],
  },
  {
    path: "work-patterns",
    element: <WorkPatterns />,
    allOfPermissions: [ApiPermission.settings_work_patterns],
  },
  {
    path: "recognitions",
    allOfPermissions: [ApiPermission.settings_recognitions],
    planFeature: ApiFeatureType.recognitions,
    children: [
      { path: "", element: <RecognitionCategoriesPage tab={RecognitionSettingsTabs.library} /> },
      {
        path: "history",
        element: <RecognitionCategoriesPage tab={RecognitionSettingsTabs.history} />,
      },
      { path: ":id", element: <RecognitionCategoryPage /> },
    ],
  },
  {
    path: "security",
    element: <SecurityPage />,
    allOfPermissions: [ApiPermission.settings_security],
  },
  {
    path: "import-data",
    allOfPermissions: [ApiPermission.data_import],
    children: [
      { path: "", element: <ImportDataPage /> },
      { path: ":import_id/edit", element: <ImportDataEditPage />, isFullScreen: true },
      { path: "new", element: <ImportDataEditPage />, isFullScreen: true },
    ],
  },
  {
    path: "useful-links",
    element: <OrganizationLinks />,
    allOfPermissions: [ApiPermission.settings_organization_links],
  },
  {
    path: "jobs",
    element: <JobsPageLayout />,
    allOfPermissions: [ApiPermission.settings_positions_levels],
    children: [
      { path: "framework", element: <JobFrameworkPage /> },
      { path: "framework/edit", element: <JobFrameworkPage mode="edit" /> },
      { path: "roles/:job_role_id", element: <JobRolePage /> },
      { path: "roles/:job_role_id/edit", element: <JobRolePage mode="edit" /> },
    ],
  },
];
